interface Action {
    type: string;
}

interface Reducers<S, A> {
    [key: string]: (state: S, action: A) => S;
}

interface CreateReducerProps<S, A> {
    initialState: S;
    reducers: Reducers<S, A>;
}

export default function createReducerFunction<S, A>({ initialState, reducers }: CreateReducerProps<S, A>) {
    return function (state: S, action: A & Action): S {
        return reducers[action.type] ? reducers[action.type](state, action) : state || initialState;
    };
}
